import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// If the server returned pre-rendered HTML (see scripts/prerender.js), hydrate
// it in place. Otherwise fall back to a fresh client render. This lets us ship
// crawlable HTML to Googlebot while still running as a normal SPA at runtime.
const hasPrerenderedContent =
  container && container.childNodes && container.childNodes.length > 0;

if (hasPrerenderedContent) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

